import { cn } from '@/lib/utils';

import { AdditionalSVGProps } from '@/models/Svg';

export const FacebookIcon = (
  props: React.SVGAttributes<SVGElement> & AdditionalSVGProps,
) => {
  const { className, fill = '#010f1d', ...rest } = props;

  return (
    <>
      <svg
        width='28'
        height='28'
        viewBox='0 0 28 28'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={cn(`fill-[${fill}]`, className)}
        {...rest}
      >
        <path d='M24.5 0.5H3.5C1.85 0.5 0.5 1.85 0.5 3.5V24.5C0.5 26.1515 1.85 27.5 3.5 27.5H14V17H11V13.2875H14V10.2125C14 6.9665 15.818 4.6865 19.649 4.6865L22.3535 4.6895V8.597H20.558C19.067 8.597 18.5 9.716 18.5 10.754V13.289H22.352L21.5 17H18.5V27.5H24.5C26.15 27.5 27.5 26.1515 27.5 24.5V3.5C27.5 1.85 26.15 0.5 24.5 0.5Z' />
      </svg>
    </>
  );
};
